import React from 'react';
import { FieldWithError } from 'components/common';
import { Modal } from 'react-bootstrap';
import { Form, Formik } from 'formik';


export const AdminModalGrant: React.FunctionComponent<{
  show: boolean,
  handleClose: any,
  onSave: any,
}> = ({ show, handleClose, onSave }) => {


  const initialValues = {
    userId: '',
  }

  const onSubmit = (data: any, actions: any) => {
    onSave(data.userId);
    handleClose();
  }

  return (
    <Modal className="admin-modal" show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header>
        <Modal.Title>Invite Users to Contest</Modal.Title>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleClose}></button>
      </Modal.Header>
      <Modal.Body style={{background:"#FFF", border: "none"}}>
        <div className="row justify-content-center">
          <Formik initialValues={initialValues} onSubmit={onSubmit}>
            {({ values, errors, touched, isSubmitting }) => {
              return (
                <Form>
                  <div className="container">

                    <FieldWithError
                      errors={errors}
                      touched={touched}
                      fieldName="userId"
                      placeholder="User ID"
                      label="User ID"
                      style={{background: "#FFF", color:"#000"}}
                    />

                    <button type="submit" className="btn btn-primary my-3" disabled={isSubmitting}>Grant Award</button>
                  </div>
                </Form>
              )
            }}
          </Formik>

        </div>
      </Modal.Body>
    </Modal>

  );
}


